<template>
	<bsh-modal 
		titulo="Editar Despesa"
		tamanho="modal-lg"
		:name="name">
		<template v-slot:default>
	        <despesa-form
	        	:dados="dados" 
				:categoria="categoria"
	        	:name="name" 
	        	:errors="errors">
	        </despesa-form>
	    </template>
	    <template v-slot:footer>
        	<button 
				ref="btnRequest"
        		type="button" 
        		class="btn btn-primary" 
        		@click="update">
        		Salvar
        	</button>
        </template>
    </bsh-modal>
</template>

<script>
	export default {
		data(){
			return {
				dados: [],
				name: 'update_despesa',
				errors: [],
				categoria: null
			}
		}, 
		created(){
			this.getDados();
		},
		methods: {
			update(){
				this.$btnFunctions.disableToggle(this.$refs.btnRequest, true)
	            axios.put(this.$url+'/api/adm/despesas/update/'+this.$route.params.id, (this.dados))
	            .then(response => {
	            	$('#'+this.name).modal('hide')
	            	this.$bshMessage.show(response.data.message, response.data.type)
	              	this.$emit('reload')
					this.$btnFunctions.disableToggle(this.$refs.btnRequest, false)
	            })
	            .catch(error => {
					this.errors = error.response.data.errors
					this.$btnFunctions.disableToggle(this.$refs.btnRequest, false)
				});
        	},
        	getDados(){
	            axios.get(this.$url+'/api/adm/despesas/show/'+this.$route.params.id)
	            .then(response => {
	                this.dados = response.data
					this.categoria = response.data.categoria.nome
	            })
			}
		}
	}
</script>